module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNDgwIiB3aWR0aD0iNjQwIiB2aWV3Qm94PSIwIDAgNjQwIDQ4MCI+CiAgPHBhdGggZmlsbD0iI2ZmZiIgZD0iTTAgMGg2NDB2NDgwSDB6Ii8+CiAgPHBhdGggZmlsbD0iI2NlMTEyNCIgZD0iTTI4MS42IDBoNzYuOHY0ODBoLTc2Ljh6Ii8+CiAgPHBhdGggZmlsbD0iI2NlMTEyNCIgZD0iTTAgMjAxLjZoNjQwdjc2LjhIMHoiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/4x3/gb-eng.svg
// module id = ./node_modules/flag-icon-css/flags/4x3/gb-eng.svg
// module chunks = 0